export class MaskedFieldInputEvent extends Event {
    constructor(type, validityState, maskedValue, unmaskedValue, originalTarget) {
        super(type, { bubbles: true, cancelable: false, composed: true });
        this.validityState = validityState;
        this.maskedValue = maskedValue;
        this.unmaskedValue = unmaskedValue;
        if (originalTarget != null) {
            this.originalTarget = originalTarget;
        }
    }
}
//# sourceMappingURL=MaskedFieldEvent.js.map